import BaseService from "./BaseService";

export default class Form433AReviewService extends BaseService {
    /** Users whose Form 433-A is ready for admin review. */
    public static getUsers(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/form433A/users', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    /** All Form 433-A questions with the user's responses, grouped by section. */
    public static getQuestions(postData: { userId: string }, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/form433A/questions', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    /** Saves the admin's responses as a draft. */
    public static saveAsDraft(postData: { userId: string, fields: any[] }, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/form433A/saveAsDraft', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    /** Generates the Form 433-A PDF from the saved responses. Returns { body: base64, isBase64Encoded }. */
    public static preview(postData: { userId: string }, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/form433A/preview', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    /** Saves the admin's responses and completes the review. */
    public static completeReview(postData: { userId: string, fields: any[] }, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/form433A/review/complete', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify({ ...postData, isApproved: true })
        });
    }

    /** gets the list of evidence for a user. */
    public static getUserEvidenceList(postData: { userId: string }, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/form433A/user/evidenceList', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static downloadEvidence(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/form433A/user/downloadEvidence', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }
}
